"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _field = _interopRequireDefault(require("./field"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _icon = _interopRequireDefault(require("../icon"));

var _flexBreak = _interopRequireDefault(require("../flex-break"));

var _attach = _interopRequireDefault(require("../attach"));

var _helpToolTip = _interopRequireDefault(require("./help-tool-tip"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ListItemField = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(ListItemField, _React$PureComponent);

  var _super = _createSuper(ListItemField);

  function ListItemField() {
    var _this;

    (0, _classCallCheck2.default)(this, ListItemField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDelete", function () {
      _this.props.component.emit('delete');
    });
    return _this;
  }

  (0, _createClass2.default)(ListItemField, [{
    key: "render",
    value: function render() {
      // Note: allowDelete and help have to be passed in as a prop as it is really the parent's values
      // that we need
      var _this$props = this.props,
          component = _this$props.component,
          allowDelete = _this$props.allowDelete,
          help = _this$props.help,
          disabled = _this$props.disabled,
          editable = _this$props.editable;

      if (component) {
        var block = component.get('block');
        return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_field.default, {
          component: component,
          block: false,
          disabled: disabled
        }), allowDelete && !disabled && editable ? /*#__PURE__*/_react.default.createElement(_IconButton.default, {
          "aria-label": "Delete",
          onClick: this.handleDelete
        }, /*#__PURE__*/_react.default.createElement(_icon.default, {
          icon: "DeleteIcon"
        })) : null, help && editable ? /*#__PURE__*/_react.default.createElement(_helpToolTip.default, {
          help: help
        }) : '', block ? /*#__PURE__*/_react.default.createElement(_flexBreak.default, null) : null);
      } else {
        // component can be falsy if it was just deleteed
        return null;
      }
    }
  }]);
  return ListItemField;
}(_react.default.PureComponent); // We want the component to update when the value changes as blank fields should not display a
// delete button


var _default = (0, _attach.default)(['value', 'disabled', 'editable'])(ListItemField);

exports.default = _default;